import BaseFolderType from 'owa-service/lib/contract/BaseFolderType';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import FindFolderParentWrapper from 'owa-service/lib/contract/FindFolderParentWrapper';
import Folder from '../store/schema/Folder';
import FolderType from 'owa-service/lib/contract/Folder';
import getDistinguishedFolderIdNameForRootFolder from '../util/getDistinguishedFolderIdNameForRootFolder';
import getFolderTable from '../selectors/getFolderTable';
import getIsFolderHiddenProperty from '../util/getIsFolderHiddenProperty';
import getSourceWellKnownFolderTypeProperty from '../util/getSourceWellKnownFolderTypeProperty';
import { mutator } from 'satcheljs';
import { updateFolderTable } from '../actions/internalActions';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Mutator that updates the folder table and sets-up parent child folder relations.
 */
export default mutator(updateFolderTable, actionMessage => {
    let folderTable = getFolderTable();
    const rootFolder: FindFolderParentWrapper = actionMessage.folder;
    const parentFolder = rootFolder.ParentFolder;
    const folderId = parentFolder.FolderId.Id;
    const distinguishedFolderIdName = getDistinguishedFolderIdNameForRootFolder(
        parentFolder,
        actionMessage.treeType
    );

    // create a folder for parent folder.
    let folder: Folder = {
        childFolderIds: [],
        distinguishedFolderId: distinguishedFolderIdName,
        UnreadCount: (<FolderType>parentFolder).UnreadCount,
        TotalCount: parentFolder.TotalCount,
        isHidden: getIsFolderHiddenProperty(parentFolder),
        sourceWellKnownFolderType: getSourceWellKnownFolderTypeProperty(parentFolder),
        treeType: actionMessage.treeType,
        principalSMTPAddress: actionMessage.principalSMTPAddress,
        ...parentFolder,
    };

    // add parent folder to folder table.
    folderTable.set(folderId, folder);

    // add rootFolder's folders to table
    let folderIds: string[] = [];
    for (let i = 0; i < rootFolder.Folders.length; i++) {
        const item: BaseFolderType = rootFolder.Folders[i];
        let folderId = item.FolderId.Id;
        let distinguishedFolderIdName = <DistinguishedFolderIdName>item.DistinguishedFolderId;
        if (!canAddFolderToFolderTable(distinguishedFolderIdName)) {
            continue;
        }

        let folder: Folder = {
            childFolderIds: [],
            distinguishedFolderId: distinguishedFolderIdName,
            UnreadCount: (<FolderType>item).UnreadCount,
            TotalCount: item.TotalCount,
            isHidden: getIsFolderHiddenProperty(item),
            sourceWellKnownFolderType: getSourceWellKnownFolderTypeProperty(item),
            treeType: actionMessage.treeType,
            principalSMTPAddress: actionMessage.principalSMTPAddress,
            ...item,
        };

        // add each of those folder to folder table.
        folderTable.set(folderId, folder);
        folderIds.push(folderId);
    }

    // set up all of the parent-child folder relations
    folderIds.forEach(folderId => {
        let folder = folderTable.get(folderId);
        let parent = folderTable.get(folder.ParentFolderId.Id);
        if (parent && !folder.isHidden) {
            parent.childFolderIds.push(folderId);
        }
    });
});

function canAddFolderToFolderTable(distinguishedFolderIdName: string): boolean {
    const isJunkEmailEnabledByAdmin = !!getUserConfiguration().SegmentationSettings.JunkEMail;
    if (distinguishedFolderIdName === 'junkemail' && !isJunkEmailEnabledByAdmin) {
        // Skip adding Junk Email folder if it's disabled by admin
        return false;
    }

    const isStickyNotesEnabledByAdmin = !!getUserConfiguration().SegmentationSettings.StickyNotes;
    if (distinguishedFolderIdName === 'notes' && !isStickyNotesEnabledByAdmin) {
        // Skip adding Notes folder if it's disabled by admin
        return false;
    }

    return true;
}
